import React, { useContext, useState } from 'react';
import { Container } from "reactstrap";
import ReactPlayer from "react-player";
import Header from "../components/Headers/Header";
import AdminNavbar from "../components/Navbars/AdminNavbar/AdminNavbar";
import LoadingSpinner from "../components/LoadingSpinner/LoadingSpinner";
import { AuthContext } from '../context/AuthContext';
import { AgendaContext } from '../context/AgendaContext';

const Home = () => {

  const { objUserTk } = useContext(AuthContext);
  const { downloadAgendaPdfByDate } = useContext(AgendaContext);
  const [selectedDate, setSelectedDate] = useState<string>("");

  const handleDownloadPdf = () => {
    if (selectedDate) {
      const date = new Date(selectedDate);
      downloadAgendaPdfByDate(date);
    }
  };


  return (
    <>
      <LoadingSpinner />
      <Header />
      <AdminNavbar
        brandText={"Página Inicial"}
        search={false}
        titleSearch={""}
      />

      {/* <Container className="mt-4">
        <div className="mb-3">
          <label htmlFor="datePicker" className="form-label">Selecione a Data:</label>
          <input
            type="date"
            id="datePicker"
            className="form-control"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </div>
        <button
          className="btn btn-primary"
          onClick={handleDownloadPdf}
          disabled={!selectedDate}
        >
          Baixar PDF da Agenda
        </button>
      </Container> */}

      {/* <div style={{ position: "relative", zIndex: 0, height: "calc(100vh - 56px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <ReactPlayer
          url={linkVideo}
          playing={false} 
          controls={true} 
          style={{ position: "inherit", top: "-15%", left: 0, right: 0, bottom: 0, margin: "auto" }}
          width="87%" 
          height="80%" 
        />
      </div> */}
    </>
  );
};

export default Home;
